import React, { useState } from 'react';

import { signatureTextCreate } from '../../../../../../services/signatures.service';
import ButtonComponent from '../../../../../common-components/ButtonComponent/ButtonComponent';
import InputComponent from '../../../../../common-components/InputComponent/InputComponent';
import ShortString from '../../../../../common-components/ShortString/ShortString';

const webSafeFonts = [
  {
    font: 'Lobster',
    size: '20.84px',
  },
  // {
  //   font: 'Caveat',
  //   size: '26px',
  // },
  {
    font: 'Signika Negative',
    size: '20.84px',
  },
  {
    font: 'Ubuntu Sans Mono',
    size: '20.28px',
  },
  {
    font: 'Pacifico',
    size: '20.84px',
  },
  {
    font: 'Patrick Hand',
    size: '20.84px',
  },
  {
    font: 'Alex Brush',
    size: '44.84px',
    disabledForInfluencerSigning: true,
  },
  {
    font: 'Ms Madi',
    size: '26px',
    disabledForInfluencerSigning: true,
  },
];

const getFonts = (isInfluencerSigning) => {
  return webSafeFonts.filter((font) => (isInfluencerSigning ? !font.disabledForInfluencerSigning : true));
};

export default function TypeSignature({ onClose, onUploadFinish, isInfluencerSigning }) {
  const [typeSignatureFormData, setTypeSignatureFormData] = useState({
    name: '',
    selectedStyle: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  const disabled = !typeSignatureFormData?.name || !typeSignatureFormData?.selectedStyle;

  const onUpload = async () => {
    if (isInfluencerSigning) {
      onUploadFinish({
        type: 'typed',
        text: typeSignatureFormData?.name,
        fontFamily: typeSignatureFormData?.selectedStyle,
      });
      return;
    }

    setIsLoading(true);
    try {
      const res = await signatureTextCreate({
        text: typeSignatureFormData?.name,
        fontStyling: { fontFamily: typeSignatureFormData?.selectedStyle },
      });

      onUploadFinish({
        type: 'typed',
        text: typeSignatureFormData?.name,
        fontFamily: typeSignatureFormData?.selectedStyle,
        _id: res?.data?._id,
      });
    } catch (error) {
      console.log('#nau3489739 signature type create failed');
    }

    setIsLoading(false);
  };

  return (
    <div>
      <InputComponent
        autoFocus
        label={'Type Your Name'}
        required
        setValue={(value) => setTypeSignatureFormData({ ...typeSignatureFormData, name: value })}
        value={typeSignatureFormData.name}
      />

      <div className="choose-style-container">
        <label>Choose the style</label>

        <div
          className={`choose-style ${typeSignatureFormData?.name ? 'purple-border' : 'grey-border'}`}
          style={{ padding: '16px' }}>
          {getFonts(isInfluencerSigning).map((font) => (
            <div
              className={`signature-style ${
                typeSignatureFormData.selectedStyle === font.font ? 'signature-style-selected' : ''
              }`}
              key={font.font}
              style={{
                fontFamily: font.font,
                display: typeSignatureFormData?.name ? undefined : 'none',
                fontSize: font.size,
                padding: 0,
              }}
              onClick={() =>
                setTypeSignatureFormData({
                  ...typeSignatureFormData,
                  selectedStyle: font.font,
                })
              }>
              <ShortString name={typeSignatureFormData?.name} stringLength={12} placement="top" />
            </div>
          ))}
        </div>
      </div>

      <div className="sign-contract-buttons-container">
        <ButtonComponent onClick={onClose} variant="secondary">
          Cancel
        </ButtonComponent>

        <ButtonComponent
          disabled={disabled}
          showLoading={isLoading}
          onClick={() => {
            onUpload();
          }}
          type="submit"
          disabledStyle={{ fontSize: '16px' }}>
          Upload
        </ButtonComponent>
      </div>
    </div>
  );
}
